module.exports = __webpack_public_path__ + "media/images/favicon_test-e87fdc2b0fed798cdf204022a08de674.png";